import { Controller } from "@hotwired/stimulus"

// Points scheme editor: a preset <select> fills the editable position→points
// table; editing any cell flips the preset to "custom".
export default class extends Controller {
  static targets = ["preset", "input"]
  static values = { presets: Object }

  applyPreset() {
    const scheme = this.presetsValue[this.presetTarget.value]
    if (!scheme) return
    this.inputTargets.forEach((input, i) => {
      input.value = scheme[i] != null ? scheme[i] : 0
    })
  }

  markCustom() {
    this.presetTarget.value = "custom"
  }
}
